import { Koi } from '@ksyos/koi';
import type { TypedReadSchema } from '@common/formEngine/typedReadSchema.types';
import type { ProcessActivityAsset } from '@common/validation/processActivityAsset';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';
import { Vervolgstap } from '@common/customControls/bariatrics';
import { getProcessActivityAssetsSchema } from '@common/validation/processActivityAsset';
import { addAllowNull } from '@common/validation/utils/addAllowNull';
import { getTextAreaStringSchema } from '@common/validation/utils/getTextAreaStringSchema';

export const bariPostNurseSpecialistReportVervolgstappen = [
    Vervolgstap.vervolgafspraak,
    Vervolgstap.terug_naar_lifestylecoach,
    Vervolgstap.geen_actie_nodig,
] as const;

export type BariPostNurseSpecialistReportVervolgstap = Extract<
    Vervolgstap,
    Vervolgstap.vervolgafspraak | Vervolgstap.terug_naar_lifestylecoach | Vervolgstap.geen_actie_nodig
>;

export type BariPostNurseSpecialistReportData = {
    assets: ProcessActivityAsset[];
    hulpvraag: string | null;
    interventie: string | null;
    verslag: string | null;
    vervolgstap: BariPostNurseSpecialistReportVervolgstap | null;
};

const bariPostNurseSpecialistReportFinal: TypedSchema<BariPostNurseSpecialistReportData> = {
    assets: getProcessActivityAssetsSchema(),
    hulpvraag: getTextAreaStringSchema(true),
    interventie: getTextAreaStringSchema(true),
    verslag: getTextAreaStringSchema(),
    vervolgstap: Koi.koi().valid(...bariPostNurseSpecialistReportVervolgstappen),
};

const bariPostNurseSpecialistReportDraft = addAllowNull(bariPostNurseSpecialistReportFinal, [
    'assets',
    'hulpvraag',
    'interventie',
]);

export const bariPostNurseSpecialistReportDraftSchema = Koi.object(bariPostNurseSpecialistReportDraft);
export const bariPostNurseSpecialistReportFinalSchema = Koi.object(bariPostNurseSpecialistReportFinal);

export type BariPostNurseSpecialistReportReadKey = keyof BariPostNurseSpecialistReportData;

export type BariPostNurseSpecialistReportReadLabel =
    | 'Bestand(en)'
    | 'Hulpvraag'
    | 'Interventie'
    | 'Verslag'
    | 'Vervolgstap';

export type BariPostNurseSpecialistReportReadSectionTitle = 'Verslag' | 'Vervolgstap';

export const bariPostNurseSpecialistReportReadSchema: TypedReadSchema<
    BariPostNurseSpecialistReportReadKey,
    BariPostNurseSpecialistReportReadLabel,
    BariPostNurseSpecialistReportReadSectionTitle
>[] = [
    {
        items: [
            {
                key: 'verslag',
                label: 'Verslag',
            },
            {
                key: 'hulpvraag',
                label: 'Hulpvraag',
            },
            {
                key: 'interventie',
                label: 'Interventie',
            },
            {
                key: 'assets',
                label: 'Bestand(en)',
            },
        ],
        sectionTitle: 'Verslag',
    },
    {
        items: [
            {
                key: 'vervolgstap',
                label: 'Vervolgstap',
            },
        ],
        sectionTitle: 'Vervolgstap',
    },
];
